import { render, staticRenderFns } from "./GameConfiguration.vue?vue&type=template&id=75466b3c"
import script from "./GameConfiguration.vue?vue&type=script&lang=js"
export * from "./GameConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports